import { createBrowserRouter } from "react-router";
import { portalBasename } from "@shared-core/routing/basename";
import { routeConfig } from "./routeConfig";

// The supplier portal's router. The route table is in ./routeConfig so the staff-view build can reuse it without
// creating this router at import (docs/features/supplier-portal-view-as/05 §6.1).
export const router = createBrowserRouter(routeConfig, {
  basename: portalBasename(import.meta.env?.BASE_URL),
});
